// eslint-disable-next-line
export interface ISettings {}

export function GetDefaultSettings(): ISettings {
  return {};
}
